import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"
import _imports_0 from '@/assets/icons/Hyphen.svg'
import _imports_1 from '@/assets/icons/Search.svg'


const _hoisted_1 = { class: "deliveryHistory" }
const _hoisted_2 = { class: "deliveryHistory__header" }
const _hoisted_3 = { class: "deliveryHistory__header-dropdowns" }
const _hoisted_4 = { class: "deliveryHistory__header-dateAndSearch" }
const _hoisted_5 = { class: "date" }
const _hoisted_6 = { class: "date-inputs" }
const _hoisted_7 = { class: "input" }
const _hoisted_8 = { class: "input" }
const _hoisted_9 = {
  key: 0,
  class: "date-error"
}
const _hoisted_10 = { class: "input-block" }
const _hoisted_11 = ["placeholder"]
const _hoisted_12 = {
  key: 1,
  class: "deliveryHistory__noReserve"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Table = _resolveComponent("Table")!
  const _component_AddDescription = _resolveComponent("AddDescription")!
  const _component_OpenQRCode = _resolveComponent("OpenQRCode")!
  const _component_PickedUpDeleteReservation = _resolveComponent("PickedUpDeleteReservation")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.loading)
      ? (_openBlock(), _createBlock(_component_Loading, { key: 0 }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Dropdown, {
            class: "deliveryHistory__header-dropdowns-dropdown",
            "selected-option": _ctx.selectedReservations.selectedOption,
            options: _ctx.selectedReservations.options,
            multiple: true,
            "data-testid": "selectReservations",
            onSelectOption: _ctx.selectReservations
          }, null, 8, ["selected-option", "options", "onSelectOption"]),
          _createVNode(_component_Dropdown, {
            class: _normalizeClass({
            'deliveryHistory__header-dropdowns-dropdown': true,
            'dropdown-status': true
          }),
            "selected-option": _ctx.getOrderStatus.selectedOption,
            options: _ctx.getOrderStatus.options,
            "data-testid": "changeOrderStatus",
            onSelectOption: _ctx.changeOrderStatus
          }, null, 8, ["selected-option", "options", "onSelectOption"]),
          _createVNode(_component_Button, {
            class: "getCSV-button",
            variant: "bordered",
            title: _ctx.$t('downloadPDF'),
            onClick: _ctx.getPDF
          }, null, 8, ["title", "onClick"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_Calendar, {
                  type: "date",
                  format: "DD/MM/YYYY",
                  value: _ctx.firstDay,
                  name: "startTime",
                  message: _ctx.$t('errorDate'),
                  "data-testid": "startTime",
                  onChange: _ctx.changeDateStartTime
                }, null, 8, ["value", "message", "onChange"])
              ]),
              _cache[5] || (_cache[5] = _createElementVNode("img", {
                class: "date-img",
                src: _imports_0,
                alt: "Hyphen"
              }, null, -1)),
              _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Calendar, {
                  type: "date",
                  format: "DD/MM/YYYY",
                  value: _ctx.today,
                  name: "endTime",
                  "data-testid": "endTime",
                  onChange: _ctx.changeDateEndTime
                }, null, 8, ["value", "onChange"])
              ])
            ])
          ]),
          (!_ctx.isDateCorrect)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(_ctx.$t('errorDate')), 1))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_10, [
            _cache[6] || (_cache[6] = _createElementVNode("img", {
              class: "dropdown-img",
              src: _imports_1,
              alt: "Search"
            }, null, -1)),
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.search) = $event)),
              class: "input-search",
              placeholder: _ctx.$t('search'),
              onInput: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.changeInput && _ctx.changeInput(...args)))
            }, null, 40, _hoisted_11), [
              [_vModelText, _ctx.search]
            ]),
            _createVNode(_component_Dropdown, {
              "class-name": "dropdown-search",
              "selected-option": _ctx.getSearchBy.selectedOption,
              options: _ctx.getSearchBy.options,
              onSelectOption: _ctx.changeSearchBy
            }, null, 8, ["selected-option", "options", "onSelectOption"])
          ])
        ])
      ]),
      (_ctx.isDateCorrect && _ctx.deliveryHistoryList.length)
        ? (_openBlock(), _createBlock(_component_Table, {
            key: 0,
            data: _ctx.deliveryHistoryList,
            columns: _ctx.columns,
            "id-active-delivery": _ctx.idActiveDelivery,
            "selected-field": "deliveryId",
            onOpenQrCode: _ctx.openQrCode,
            onAddDescription: _ctx.addDescription,
            onGoToItem: _ctx.addDescription
          }, null, 8, ["data", "columns", "id-active-delivery", "onOpenQrCode", "onAddDescription", "onGoToItem"]))
        : _createCommentVNode("", true),
      (!_ctx.isDateCorrect || !_ctx.deliveryHistoryList.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('noData')), 1)
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_AddDescription, {
      "show-modal": _ctx.showModal,
      "active-delivery": _ctx.activeDelivery,
      "is-add-description": _ctx.isAddDescription,
      "box-id": _ctx.boxId,
      onUpdateList: _ctx.updateList,
      onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showModal = false))
    }, null, 8, ["show-modal", "active-delivery", "is-add-description", "box-id", "onUpdateList"]),
    _createVNode(_component_OpenQRCode, {
      "show-qr-code": _ctx.showQrCode,
      "id-active-delivery": _ctx.idActiveDelivery,
      "show-only-delivery-id": _ctx.showOnlyDeliveryID,
      onCloseModal: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showQrCode = false))
    }, null, 8, ["show-qr-code", "id-active-delivery", "show-only-delivery-id"]),
    _createVNode(_component_PickedUpDeleteReservation, {
      "show-modal-delete": _ctx.showModalDelete,
      "id-delivery": _ctx.idDelivery,
      onPickedUpdeletedOrRemovedRequest: _ctx.pickedUpdeletedOrRemovedRequest,
      onCloseModal: _cache[4] || (_cache[4] = ($event: any) => (_ctx.showModalDelete = false))
    }, null, 8, ["show-modal-delete", "id-delivery", "onPickedUpdeletedOrRemovedRequest"])
  ], 64))
}